import React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";
import { firebase, auth } from "./../helper/helperFirebaseAuth";
import { Helmet } from 'react-helmet';
import { apiPost } from '../helper/helperApi';
import ComLoading from './components/comLoading';


const PageSignIn = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const fromUrl = location.state?.from?.pathname || "/app/profile";

    React.useEffect(() => {
        const ui =
            firebaseui.auth.AuthUI.getInstance() ||
            new firebaseui.auth.AuthUI(auth);

        const uiConfig = {
            signInFlow: "popup", //"redirect"
            signInSuccessUrl: fromUrl,
            signInOptions: [
                firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                'microsoft.com',
                'yahoo.com',
            ],
            callbacks: {
                signInSuccessWithAuthResult: (_authResult) => {
                    try {
                        apiPost("/auth/signin")
                            .then(() => {
                                navigate(fromUrl, { replace: true });
                            })
                            .catch((error) => {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Sign-in Error',
                                    text: error?.message || 'There was an error signing in. Please try again later.',
                                    timer: 1500,
                                });
                            });

                        // Return false to prevent the default redirect behavior
                        return false; // Prevent internal redirect after sign-in
                    }
                    catch (error) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Sign-in Error',
                            text: 'There was an error signing in. Please try again later.',
                            timer: 1500,
                        });
                    }
                    return false; // Prevent internal redirect after sign-in
                },
            },
        };

        ui.start("#firebaseui-auth-container", uiConfig);

        // cleanup function to reset the UI instance
        return () => ui.reset();
    }, []);

    return <>
        <Helmet>
            <title>Login | Sparkling Email</title>
            <meta name="description" content="Login to Sparkling Email to access your account and manage your services." />
        </Helmet>
        <section
            className="d-flex flex-column align-items-center justify-content-center text-center bg-light text-dark py-5"
            style={{ minHeight: '60vh' }}
        >
            <h1 className="mt-5">Welcome to Sparkling Email!</h1>
            <div className="text-muted">To access your account, please sign in.</div>
            <div className='d-flex flex-column gap-2 my-4'>
                <div id="firebaseui-auth-container" />
            </div>
            <div className="text-center text-muted fs-8 mb-5">
                <div>If you need assistance logging in, <a
                    href="mailto:support@sparklingemail.com"
                    className="text-decoration-none text-dark fw-semibold"
                    title="Contact Support"
                    target="_blank"
                    rel="noreferrer noopener"
                >contact our support team</a> for help.</div>
            </div>
        </section>
    </>
};

export default PageSignIn;